import { ENDPOINTS } from '../constants/apiEndpoints';
import { axiosInterceptAccessTokenExpiry } from './axios/axiosIntercepted';
import { TGeneralResponse, TResponseResult } from './dto/common.dto';

export const commitBlockChangesApi = (): TGeneralResponse<TResponseResult> =>
  axiosInterceptAccessTokenExpiry().put(`${ENDPOINTS.BOT}/restart`);
